module.exports = __webpack_public_path__ + "img/suixintui.91d9b9b9.png";